import { useMutation, UseMutationOptions, MutationFunction } from 'react-query'

import { ApiErrorBase } from 'api/core/ApiErrorBase'

import { useOnApiError } from './useOnApiError'

/**
 * Override default mutation onError functions to catch the unauthorized errors and refresh the session
 */
export function useApiMutation<TData = unknown, TVariables = void, TContext = unknown>(
  mutationFn: MutationFunction<TData, TVariables>,
  options?: Omit<UseMutationOptions<TData, ApiErrorBase, TVariables, TContext>, 'mutationFn'>,
) {
  return useMutation<TData, ApiErrorBase, TVariables, TContext>(mutationFn, {
    ...options,
    onError: useOnApiError(options?.onError),
  })
}
